import React, { JSX } from 'react';
import { RaceRangerWordmarkImg } from '../components/branding/RaceRangerBrand';
import InlineSpinner from '../components/shared/InlineSpinner';

type LoginScreenProps = {
  onLogin: () => void;
  loading?: boolean;
};

function LoginScreen({ onLogin, loading }: LoginScreenProps): JSX.Element {
  return (
    <div
      className="h-screen flex items-center justify-center relative overflow-hidden"
      style={{ background: '#060d1a' }}
    >
      {/* Ambient glow blobs */}
      <div
        className="absolute pointer-events-none"
        style={{
          top: '-20%', left: '-10%',
          width: '70%', height: '70%',
          borderRadius: '50%',
          background: 'radial-gradient(circle, rgba(59,130,246,0.12) 0%, transparent 70%)',
          filter: 'blur(40px)',
        }}
      />
      <div
        className="absolute pointer-events-none"
        style={{
          bottom: '-20%', right: '-10%',
          width: '60%', height: '60%',
          borderRadius: '50%',
          background: 'radial-gradient(circle, rgba(99,102,241,0.1) 0%, transparent 70%)',
          filter: 'blur(40px)',
        }}
      />

      {/* Subtle grid */}
      <div
        className="absolute inset-0 pointer-events-none opacity-[0.025]"
        style={{
          backgroundImage: 'linear-gradient(rgba(255,255,255,0.4) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.4) 1px, transparent 1px)',
          backgroundSize: '48px 48px',
        }}
      />

      {/* Card */}
      <div
        className="relative w-full max-w-[400px] mx-4 rounded-2xl p-8 flex flex-col items-center"
        style={{
          background: 'rgba(15,25,41,0.85)',
          backdropFilter: 'blur(20px)',
          WebkitBackdropFilter: 'blur(20px)',
          border: '1px solid rgba(255,255,255,0.09)',
          boxShadow: '0 24px 80px rgba(0,0,0,0.6), inset 0 1px 0 rgba(255,255,255,0.06)',
        }}
      >
        {/* Brand */}
        <div className="mb-6 flex w-full flex-col items-center px-2">
          <RaceRangerWordmarkImg className="max-h-[4.25rem] w-auto max-w-[min(100%,380px)] sm:max-h-[4.75rem]" />
        </div>

        <p className="text-xs text-gray-500 dark:text-slate-400 mb-8 tracking-wide uppercase">
          Fleet Manager
        </p>


        {/* Sign in button */}
        <button
          onClick={onLogin}
          disabled={loading}
          className={[
            'w-full rounded-xl py-3 text-sm font-semibold text-white transition-all duration-150',
            loading
              ? 'opacity-50 cursor-not-allowed'
              : 'hover:-translate-y-[1px] active:translate-y-0',
          ].join(' ')}
          style={{
            background: loading
              ? 'rgba(59,130,246,0.5)'
              : 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)',
            boxShadow: loading ? 'none' : '0 4px 20px rgba(59,130,246,0.4)',
          }}
        >
          {loading ? (
            <span className="flex items-center justify-center gap-2">
              <InlineSpinner className="border-white/30 border-t-white" />
              Opening sign-in…
            </span>
          ) : (
            'Sign In'
          )}
        </button>

        <p className="mt-5 text-[11px] text-gray-600 dark:text-slate-300 text-center">
          Raceranger Ltd · Fleet Management System
        </p>
      </div>
    </div>
  );
}

export default LoginScreen;
